import { DataGridLocaleTextColumn } from '@app/components/atoms/data-grid-locale-text-column'
import { CopyEntity, CopyPopover } from '@app/components/copier'
import { DeleteEntityButton, ToggleButton } from '@app/components/deleteEntityButton'
import { CaseStudyForm } from '@app/components/forms/case-study-form'
import { PreviewButton } from '@app/components/previewButton'
import { Binding, DeleteEntityDialog, PersistButton } from '@app/lib/binding'
import { BackButton } from '@app/lib/buttons'
import { DataGrid, DataGridColumn, DataGridLoader, DataGridPagination, DataGridQueryFilter, DataGridTable, DataGridToolbar } from '@app/lib/datagrid'
import { Slots } from '@app/lib/layout'
import { AnchorButton, Button } from '@app/lib/ui/button'
import { EntitySubTree, Link, RedirectOnPersist } from '@contember/interface'
import { TrashIcon } from 'lucide-react'
import { useState } from 'react'

export const List = () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Case study list</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<>
						<Slots.Actions>
							<Link to="caseStudy/create">
								<Button>Create case study</Button>
							</Link>
						</Slots.Actions>
						<DataGrid entities="CaseStudy">
							<DataGridToolbar>
								<DataGridQueryFilter />
							</DataGridToolbar>
							<DataGridLoader>
								<DataGridTable>
									<DataGridColumn>
										<div className="flex gap-4">
											<Link to="caseStudy/edit(id: $entity.id)">
												<Button variant="outline">Edit</Button>
											</Link>
										</div>
									</DataGridColumn>
									<DataGridLocaleTextColumn field="title" header="Title" />
									<DataGridLocaleTextColumn field="link.url" header="Url" />
									<DataGridColumn>
										<div className="flex justify-end items-center gap-4">
											<DeleteEntityDialog
												trigger={
													<Button variant="destructive" size="sm">
														<TrashIcon className="w-3 h-3" />
													</Button>
												}
											/>
										</div>
									</DataGridColumn>
								</DataGridTable>
							</DataGridLoader>
							<DataGridPagination />
						</DataGrid>
					</>
				</div>
			</Binding>
		</>
	)
}

export const Create = () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Case study create</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<EntitySubTree entity="CaseStudy" isCreating>
						<RedirectOnPersist to="caseStudy/edit(id: $entity.id)" />
						<Slots.Actions>
							<CopyPopover />
							<PersistButton />
						</Slots.Actions>
						<CaseStudyForm />
					</EntitySubTree>
					<CopyEntity entityName="CaseStudy">
						<CaseStudyForm />
					</CopyEntity>
				</div>
			</Binding>
		</>
	)
}

export const Edit = () => {
	const [showDeleteButton, setShowDeleteButton] = useState(false)

	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Case study edit</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<EntitySubTree entity="CaseStudy(id=$id)" isCreating={false}>
						<Slots.Actions>
							<div className="flex items-start gap-4">
								<CopyPopover>
									<Link to="caseStudy/create(copy: $entity.id)">
										<AnchorButton variant="secondary">Duplicate</AnchorButton>
									</Link>
								</CopyPopover>
								<PersistButton />
								<div className="flex flex-col items-end">
									<PreviewButton pageType="caseStudy" />
									<ToggleButton isOpen={showDeleteButton} onClick={() => setShowDeleteButton(!showDeleteButton)} />
									{showDeleteButton && <DeleteEntityButton />}
								</div>
							</div>
						</Slots.Actions>
						<CaseStudyForm />
					</EntitySubTree>
				</div>
			</Binding>
		</>
	)
}
